//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        list: {
            type: Array,
            required: true
        },
        name: {
            type: String,
            default: 'img'
        },
        setHeight: {
            type: [String, Number],
            default: null
        },
        navigation: {
            type: Boolean,
            default: true
        },
        paginationBottom: {
            type: [String, Number],
            default: 100
        }
    },
    data() {
        return {
            swiper: null,
            height: 0
        };
    },
    computed: {
        imgs() {
            console.log('imgs', this.list);
            var arr = this.list.map(item => {
                return item[this.name] || item;
            });
            return arr;
        }
    },
    mounted() {
        this.height = this.setHeight || document.documentElement.clientHeight;
        if (!isNaN(this.height)) {
            this.height = this.height + 'px';
        }
        const config = {
            autoplay: {
                disableOnInteraction: false
            },
            effect: 'fade',
            speed: 1000,
            direction: 'horizontal', // 垂直切换选项
            loop: true, // 循环模式选项
            pagination: {
                el: '.swiper-pagination'
            },
            // 如果需要前进后退按钮
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            }
        };
        var mySwiper = new window.Swiper('.swiper-container', config);
        this.swiper = mySwiper;
    },
    methods: {
        prev() {
            this.swiper.slidePrev();
        },
        next() {
            this.swiper.slideNext();
        }
    }
};
